<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-xs">
      <div class="max-w-[1600px] mx-auto space-y-4">

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-2 flex gap-2">
                  <button (click)="setTab('entity')"
                        [ngClass]="activeTab === 'entity' ? 'bg-blue-600 text-white shadow-sm' : 'bg-slate-50 text-slate-600 hover:bg-slate-100'"
                        class="px-6 py-2 rounded font-black uppercase text-[10px] tracking-widest transition-all">
                        1. Entities (Schema)
                  </button>
                  <button (click)="setTab('field')"
                        [ngClass]="activeTab === 'field' ? 'bg-blue-600 text-white shadow-sm' : 'bg-slate-50 text-slate-600 hover:bg-slate-100'"
                        class="px-6 py-2 rounded font-black uppercase text-[10px] tracking-widest transition-all">
                        2. Fields (Properties)
                  </button>
                  <button (click)="setTab('ui')"
                        [ngClass]="activeTab === 'ui' ? 'bg-blue-600 text-white shadow-sm' : 'bg-slate-50 text-slate-600 hover:bg-slate-100'"
                        class="px-6 py-2 rounded font-black uppercase text-[10px] tracking-widest transition-all">
                        3. UI Layouts (Design)
                  </button>
            </div>

            <div *ngIf="activeTab === 'entity'" class="animate-in fade-in duration-300">
                  <div
                        class="bg-white rounded-md shadow-sm border border-slate-200 p-3 mb-3 flex items-center justify-between">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta Entity
                                    Management</h2>
                              <p class="text-[10px] text-slate-500 uppercase">System Schema Configuration</p>
                        </div>
                        <div class="flex items-center gap-2">
                              <input type="text" [(ngModel)]="entitySearch" (input)="applyEntityFilter()"
                                    placeholder="Search Entities..."
                                    class="w-48 px-3 py-1.5 border border-slate-200 rounded text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                              <button (click)="openEntityCreate()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded font-semibold">+
                                    New Entity</button>
                        </div>
                  </div>

                  <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">
                        <table class="w-full text-left border-collapse">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] uppercase tracking-wider">
                                          <th class="px-3 py-2 font-bold" style="width: 15%">Code</th>
                                          <th class="px-3 py-2 font-bold" style="width: 25%">Entity Name</th>
                                          <th class="px-3 py-2 font-bold text-center" style="width: 10%">Mode</th>
                                          <th class="px-3 py-2 font-bold" style="width: 30%">Data Flow</th>
                                          <th class="px-3 py-2 font-bold text-right" style="width: 12%">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of entityList" class="hover:bg-blue-50/50 transition-colors">
                                          <td class="px-3 py-2 font-mono font-bold text-blue-700 uppercase">{{ m.code }}
                                          </td>
                                          <td class="px-3 py-2 text-slate-700 font-medium uppercase">{{ m.name }}</td>
                                          <td class="px-3 py-2 text-center"><span
                                                      class="px-1.5 py-0.5 rounded bg-slate-100 border border-slate-200 text-slate-600 text-[10px] uppercase">{{
                                                      m.viewmode }}</span></td>
                                          <td class="px-3 py-2">
                                                <p
                                                      class="truncate max-w-[200px] font-mono text-[10px] text-slate-400 bg-slate-50 px-1 rounded border border-slate-100">
                                                      {{ m.dataFlow }}</p>
                                          </td>
                                          <td class="px-3 py-2 text-right">
                                                <button (click)="openEntityEdit(m)"
                                                      class="p-1 hover:text-blue-600 text-slate-400 font-bold uppercase text-[10px]">Edit</button>
                                                <button (click)="deleteEntity(m.id!)"
                                                      class="p-1 hover:text-red-600 text-slate-400 font-bold uppercase text-[10px]">Del</button>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>

                        <div class="flex items-center justify-between px-4 py-2.5 bg-white border-t border-slate-200">
                              <select [value]="entitySize" (change)="changeEntitySize($event)"
                                    class="border-2 border-slate-200 rounded px-2 py-1 text-xs">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                              </select>
                              <div class="flex gap-1">
                                    <button (click)="goEntityPage(entityPage - 1)" [disabled]="entityPage === 0"
                                          class="px-2 py-1 border rounded disabled:opacity-30">&lt;</button>
                                    <button (click)="goEntityPage(entityPage + 1)"
                                          [disabled]="(entityPage + 1) * entitySize >= entityTotal"
                                          class="px-2 py-1 border rounded disabled:opacity-30">&gt;</button>
                              </div>
                        </div>
                  </div>
            </div>

            <div *ngIf="activeTab === 'field'" class="animate-in fade-in duration-300">
                  <div
                        class="bg-white rounded-md shadow-sm border border-slate-200 p-3 mb-3 flex items-center justify-between">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta Field
                                    Management</h2>
                              <p class="text-[10px] text-slate-500 uppercase">Dynamic UI Properties</p>
                        </div>
                        <div class="flex items-center gap-2">
                              <input type="text" [(ngModel)]="fieldSearch" (input)="applyFieldFilter()"
                                    placeholder="Search Fields..."
                                    class="w-48 px-3 py-1.5 border border-slate-200 rounded text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                              <button (click)="openFieldCreate()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded font-semibold">+
                                    New Field</button>
                        </div>
                  </div>

                  <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-x-auto">
                        <table class="w-full text-left border-collapse min-w-[1000px]">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] uppercase tracking-wider font-bold">
                                          <th class="px-3 py-1.5 w-32">Entity / ID</th>
                                          <th class="px-3 py-1.5 w-40">Label / Name</th>
                                          <th class="px-3 py-1.5 w-32">Type / Category</th>
                                          <th class="px-3 py-1.5 w-16 text-center">Req.</th>
                                          <th class="px-3 py-1.5 w-24 text-right">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of fieldList" class="hover:bg-blue-50/50 transition-colors">
                                          <td class="px-3 py-1.5">
                                                <div class="font-bold text-slate-800 text-[11px] uppercase">{{
                                                      m.entityName }}</div>
                                                <div
                                                      class="text-[10px] font-mono text-blue-600 font-bold uppercase truncate">
                                                      {{ m.fieldId }}</div>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <div class="font-medium text-slate-800 text-[11px]">{{ m.label }}</div>
                                                <div class="text-[10px] text-slate-400 font-mono">{{ m.name }}</div>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <span
                                                      class="px-2 py-0.5 rounded bg-blue-50 border border-blue-100 text-blue-700 text-[9px] uppercase font-bold">{{
                                                      m.type }}</span>
                                          </td>
                                          <td class="px-3 py-1.5 text-center">
                                                <span
                                                      [class]="m.isRequired ? 'text-red-500 font-bold text-[10px]' : 'text-slate-300 text-[10px]'">{{
                                                      m.isRequired ? 'YES' : 'NO' }}</span>
                                          </td>
                                          <td class="px-3 py-1.5 text-right">
                                                <button (click)="openFieldEdit(m)"
                                                      class="p-1 hover:text-blue-600 text-slate-400 font-bold uppercase text-[10px]">Edit</button>
                                                <button (click)="deleteField(m.id)"
                                                      class="p-1 hover:text-red-600 text-slate-400 font-bold uppercase text-[10px]">Del</button>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>

                        <div class="flex items-center justify-between px-4 py-2.5 bg-white border-t border-slate-200">
                              <select [value]="fieldSize" (change)="changeFieldSize($event)"
                                    class="border-2 border-slate-200 rounded px-2 py-1 text-xs">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                              </select>
                              <div class="flex gap-1">
                                    <button (click)="goFieldPage(fieldPage - 1)" [disabled]="fieldPage === 0"
                                          class="px-2 py-1 border rounded disabled:opacity-30">&lt;</button>
                                    <button (click)="goFieldPage(fieldPage + 1)"
                                          [disabled]="(fieldPage + 1) * fieldSize >= fieldTotal"
                                          class="px-2 py-1 border rounded disabled:opacity-30">&gt;</button>
                              </div>
                        </div>
                  </div>
            </div>

            <div *ngIf="activeTab === 'ui'" class="animate-in fade-in duration-300">
                  <div
                        class="bg-white rounded border border-slate-200 p-3 mb-3 flex items-center justify-between shadow-sm">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta UI Designer
                              </h2>
                              <p class="text-[10px] text-slate-400 uppercase font-bold tracking-tight">Manage Layout
                                    Schemas</p>
                        </div>
                        <div class="flex items-center gap-2">
                              <input type="text" [(ngModel)]="uiSearch" (input)="applyUiFilter()"
                                    placeholder="SEARCH SCHEMAS..."
                                    class="w-48 px-3 py-1.5 border border-slate-200 rounded text-[10px] font-bold uppercase focus:ring-1 focus:ring-blue-500 outline-none transition-all shadow-sm" />
                              <button (click)="openUiCreate()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-[10px] font-black uppercase transition-all shadow-sm">+
                                    NEW SCHEMA</button>
                        </div>
                  </div>

                  <div class="bg-white rounded border border-slate-200 overflow-hidden relative shadow-sm w-full">
                        <div *ngIf="uiLoading"
                              class="absolute inset-0 bg-white/60 z-10 flex items-center justify-center">
                              <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                        </div>
                        <table class="w-full text-left border-collapse">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[9px] uppercase tracking-widest font-black">
                                          <th class="px-4 py-3">Entity Reference</th>
                                          <th class="px-4 py-3">UI Schema Preview</th>
                                          <th class="px-4 py-3 text-right">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of uiList" class="hover:bg-slate-50/50 transition-colors">
                                          <td class="px-4 py-3 font-bold text-slate-700 text-[10px] uppercase">{{
                                                m.entityName }}</td>
                                          <td class="px-4 py-3">
                                                <div
                                                      class="max-w-md truncate font-mono text-blue-600 bg-blue-50/40 px-2 py-1 rounded border border-blue-100 text-[9px]">
                                                      {{ m.uiSchema }}
                                                </div>
                                          </td>
                                          <td class="px-4 py-3 text-right">
                                                <button (click)="openUiEdit(m)"
                                                      class="p-1 hover:text-blue-600 text-slate-400 font-bold uppercase text-[10px] mr-2">Edit</button>
                                                <button (click)="deleteUi(m.id)"
                                                      class="p-1 hover:text-red-600 text-slate-400 font-bold uppercase text-[10px]">Del</button>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>

                        <div class="flex items-center justify-between px-4 py-3 bg-white border-t border-slate-200">
                              <select [(ngModel)]="uiSize" (change)="changeUiSize()"
                                    class="border-2 border-slate-100 rounded px-2 py-1 text-xs">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                              </select>
                              <div class="flex gap-1">
                                    <button (click)="prevUiPage()" [disabled]="uiPage === 0"
                                          class="px-2 py-1 border rounded disabled:opacity-30">&lt;</button>
                                    <button (click)="nextUiPage()" [disabled]="(uiPage + 1) * uiSize >= uiTotal"
                                          class="px-2 py-1 border rounded disabled:opacity-30">&gt;</button>
                              </div>
                        </div>
                  </div>
            </div>

      </div>
</div>

<div *ngIf="isEntityModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-[2px]">
      <div
            class="bg-white rounded-lg shadow-xl w-full max-w-lg p-5 border border-slate-200 animate-in zoom-in duration-200">
            <div class="flex justify-between items-center border-b border-slate-100 pb-3 mb-4">
                  <h3 class="text-sm font-bold text-slate-800 uppercase tracking-tight">{{ isEntityEdit ? 'Modify' :
                        'Create' }} Meta Entity</h3>
                  <button (click)="closeEntityModal()"
                        class="text-slate-400 hover:text-slate-600 transition-colors text-lg">✕</button>
            </div>
            <div class="grid grid-cols-2 gap-4">
                  <div class="col-span-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Entity Code (Auto
                              Uppercase)</label>
                        <input [(ngModel)]="entityForm.code"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none font-mono uppercase">
                  </div>
                  <div class="col-span-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Entity Name (Auto
                              Uppercase)</label>
                        <input [(ngModel)]="entityForm.name"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none uppercase">
                  </div>
                  <div class="col-span-2">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">View Mode</label>
                        <select [(ngModel)]="entityForm.viewmode"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none bg-white">
                              <option value="grid">Grid View</option>
                              <option value="form">Form View</option>
                              <option value="tab">Tab Layout</option>
                        </select>
                  </div>
                  <div class="col-span-2">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Data Flow (JSON
                              Configuration)</label>
                        <textarea [(ngModel)]="entityForm.dataFlow" rows="4"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-[11px] font-mono focus:ring-1 focus:ring-blue-500 outline-none bg-slate-50"
                              placeholder='{ "key": "value" }'></textarea>
                  </div>
            </div>
            <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
                  <button (click)="closeEntityModal()"
                        class="px-4 py-1.5 border border-slate-200 text-slate-600 rounded text-xs font-semibold">Cancel</button>
                  <button (click)="saveEntity()" class="px-4 py-1.5 bg-blue-600 text-white rounded text-xs font-bold">{{
                        isEntityEdit ? 'UPDATE RECORD' : 'SAVE ENTITY' }}</button>
            </div>
      </div>
</div>

<div *ngIf="isFieldModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-[1px]">
      <div
            class="bg-white rounded shadow-xl w-full max-w-5xl border border-slate-200 overflow-hidden animate-in zoom-in duration-150">
            <div class="flex justify-between items-center border-b border-slate-100 px-5 py-3 bg-slate-50">
                  <h3 class="text-xs font-bold text-slate-800 uppercase tracking-tight">{{ isFieldEdit ? 'Modify' :
                        'New' }} Configuration Field</h3>
                  <button (click)="closeFieldModal()"
                        class="text-slate-400 hover:text-slate-600 text-lg font-bold">✕</button>
            </div>
            <div class="p-5 grid grid-cols-4 gap-x-4 gap-y-3 max-h-[75vh] overflow-y-auto">

                  <div class="group col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Target Entity</label>
                        <input type="text" [(ngModel)]="entitySearchTerm" placeholder="Search Entity..."
                              class="mb-1 w-full border border-slate-200 rounded px-2 py-1 text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                        <select [(ngModel)]="fieldForm.entityId"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                              <option [value]="null" disabled>-- Select Entity --</option>
                              <option *ngFor="let ent of filteredSharedEntities" [value]="ent.id">{{ ent.name |
                                    uppercase }} ({{ ent.code | uppercase }})</option>
                        </select>
                  </div>

                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Field ID</label>
                        <input [(ngModel)]="fieldForm.fieldId"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none font-mono font-bold text-blue-600">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">System Name</label>
                        <input [(ngModel)]="fieldForm.name"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Display Label</label>
                        <input [(ngModel)]="fieldForm.label"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Control Type</label>
                        <select [(ngModel)]="fieldForm.type"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs">
                              <option value="text">Text Input</option>
                              <option value="select">Select Menu</option>
                              <option value="autocomplete">Autocomplete</option>
                              <option value="datepicker">Date Picker</option>
                        </select>
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Category</label>
                        <select [(ngModel)]="fieldForm.category"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs">
                              <option value="static">Static</option>
                              <option value="dynamic">Dynamic</option>
                        </select>
                  </div>
            </div>
            <div class="flex justify-end gap-2 p-4 border-t border-slate-100 bg-slate-50">
                  <button (click)="closeFieldModal()"
                        class="px-4 py-1.5 border border-slate-200 text-slate-600 rounded font-bold hover:bg-white text-[10px] uppercase transition-all">Cancel</button>
                  <button (click)="saveField()"
                        class="px-6 py-1.5 bg-blue-600 text-white rounded font-bold hover:bg-blue-700 shadow-sm text-[10px] uppercase transition-all">{{
                        isFieldEdit ? 'Update Configuration' : 'Save New Field' }}</button>
            </div>
      </div>
</div>

<div *ngIf="isUiModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-6">
      <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" (click)="closeUiModal()"></div>
      <div
            class="relative bg-white w-full max-w-4xl h-[85vh] rounded-lg shadow-2xl flex flex-col overflow-hidden border border-slate-200">
            <div class="px-6 py-4 border-b border-slate-200 bg-slate-50 flex items-center justify-between">
                  <div class="flex items-center gap-3">
                        <div>
                              <h3 class="text-xs font-black text-slate-800 uppercase tracking-tighter">{{ uiSelectedId ?
                                    'Update Schema' : 'Initialize New UI' }}</h3>
                              <p class="text-[9px] text-slate-400 uppercase font-bold tracking-widest">Configuration
                                    Designer</p>
                        </div>
                  </div>
                  <button (click)="closeUiModal()"
                        class="text-slate-400 hover:text-slate-600 text-2xl transition-colors">&times;</button>
            </div>
            <div class="flex-1 overflow-y-auto p-6 space-y-6">

                  <div>
                        <label class="block text-[10px] font-black text-slate-500 uppercase mb-2 tracking-widest">Select
                              Target Entity</label>
                        <input type="text" [(ngModel)]="entitySearchTerm" placeholder="Search Entity..."
                              class="mb-1 w-full border border-slate-200 rounded px-2 py-1 text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                        <select [(ngModel)]="uiForm.entityId"
                              class="w-full px-4 py-2.5 border border-slate-200 rounded text-[11px] font-bold uppercase bg-slate-50 focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all">
                              <option value="" disabled>-- CHOOSE ENTITY --</option>
                              <option *ngFor="let ent of filteredSharedEntities" [value]="ent.id">{{ ent.name |
                                    uppercase }} ({{ ent.code | uppercase }})</option>
                        </select>
                  </div>

                  <div class="flex flex-col h-[400px]">
                        <label class="block text-[10px] font-black text-slate-500 uppercase mb-2 tracking-widest">UI
                              Schema Definition (JSON)</label>
                        <textarea [(ngModel)]="uiForm.uiSchema" spellcheck="false"
                              class="flex-1 w-full p-4 font-mono text-[10px] text-emerald-500 bg-slate-900 border border-slate-800 rounded outline-none leading-relaxed resize-none shadow-inner"
                              placeholder='{ "type": "layout", "rows": [] }'></textarea>
                  </div>
            </div>
            <div class="px-6 py-4 bg-slate-50 border-t border-slate-200 flex items-center justify-between">
                  <p class="text-[9px] text-slate-400 font-bold uppercase italic">Ensure JSON format is valid before
                        saving</p>
                  <div class="flex gap-3">
                        <button (click)="closeUiModal()"
                              class="px-5 py-2 border border-slate-300 rounded text-slate-600 hover:bg-white transition-all font-black text-[10px] uppercase tracking-widest">Discard</button>
                        <button (click)="saveUi()" [disabled]="uiLoading"
                              class="px-8 py-2 bg-blue-600 text-white rounded font-black hover:bg-blue-700 transition-all shadow-lg shadow-blue-500/20 uppercase tracking-widest text-[10px] disabled:opacity-50">
                              {{ uiLoading ? 'Saving...' : (uiSelectedId ? 'Push Changes' : 'Save Schema') }}
                        </button>
                  </div>
            </div>
      </div>
</div>